var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2 26 .486.625L5.11 30h21.775l3.11-4-7.776-10 7.29-9.375.486-.625-3.11-4H5.11l-.495.637L2 6l7.777 10L2 26zm9.378-2a.783.783 0 0 1-.618-1.264L12.887 20l3.11 4h-4.62zm10.346-8.637 6.795-8.738h-12.59a.49.49 0 0 0-.387.79l.455.585h4.62c.652 0 1.018.75.618 1.264L19.11 12l2.614 3.363zM2.99 6l15.316 19.694.11.14a.49.49 0 0 1-.386.79H3.477l2.14 2.75h19.79L5.112 3.275 2.992 6z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdex);
export default __webpack_public_path__ + "static/media/IDEX.6543063e96d334e74660e1574057e4bc.svg";
export { ForwardRef as ReactComponent };